// useRideRecorder.ts
// ==================
//
// Wave 14ca-fix41: React-Hooks rund um den rideRecorder-Bus.
// - useRecorderState: liefert den aktuellen RecorderState (idle | recording),
//   re-rendert bei Aenderung.
// - useGpsToRecorderBridge: subscribed auf positionBus und appendet jeden
//   neuen Fix in den Recorder. Caller mountet das einmalig auf App-Ebene.

import { useEffect, useState } from 'react';
import { positionBus } from './positionBus';
import {
  rideRecorder,
  type RecorderState,
  type RidePoint,
} from './rideRecorder';

export function useRecorderState(): RecorderState {
  const [s, setS] = useState<RecorderState>(rideRecorder.get());
  useEffect(() => {
    setS(rideRecorder.get());
    return rideRecorder.subscribe(setS);
  }, []);
  return s;
}

/** Hook der GPS-Updates → Recorder weiterreicht. Einmal in App.tsx mounten.
    Subscribe-Listener wird auf jeden positionBus-Tick gefeuert; wir
    appendaten nur wenn Recorder aktiv. */
export function useGpsToRecorderBridge(): void {
  useEffect(() => {
    const onPos = (coords: GeolocationCoordinates | null) => {
      if (!coords) return;
      const state = rideRecorder.get();
      if (state.kind !== 'recording') return;
      const p: RidePoint = {
        lat: coords.latitude,
        lon: coords.longitude,
        ele:
          typeof coords.altitude === 'number' && Number.isFinite(coords.altitude)
            ? coords.altitude
            : undefined,
        t: Date.now(),
        speed:
          typeof coords.speed === 'number' && Number.isFinite(coords.speed)
            ? coords.speed
            : undefined,
      };
      // Fire-and-forget: appendPoint persistiert IDB-Checkpoints intern, wir
      // brauchen das Promise hier nicht abzuwarten.
      void rideRecorder.appendPoint(p);
    };
    return positionBus.subscribe(onPos);
  }, []);
}
